import { render, staticRenderFns } from "./Signup-by-IIn-additional-info.vue?vue&type=template&id=060b1449&scoped=true"
import script from "./Signup-by-IIn-additional-info.vue?vue&type=script&lang=js"
export * from "./Signup-by-IIn-additional-info.vue?vue&type=script&lang=js"
import style0 from "./Signup-by-IIn-additional-info.vue?vue&type=style&index=0&id=060b1449&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060b1449",
  null
  
)

export default component.exports